import React, { useEffect } from 'react';
import FormField from '@ingka/form-field';
import InputField from '@ingka/input-field';
import { useTranslation } from '@ikea-customer-self-serve/gatsby-plugin-translations';
import DaumZipComponent from './DaumZipComponent';
import useZipCode from '../hooks/useZipCode';

export interface ZipCodeProps {
  name: string;
  defaultValue: string;
  isValid: boolean;
  setIsValid: (value: boolean) => void;
  customRef: React.RefObject<HTMLInputElement>;
}

const ZipCode: React.FC<ZipCodeProps> = ({
  name,
  defaultValue,
  isValid,
  setIsValid,
  customRef,
}): JSX.Element => {
  const [{ newZipCode }, { handleBlur, handleChange }] = useZipCode(
    defaultValue,
    setIsValid,
  );
  const { t } = useTranslation();
  const { COUNTRY } = CSS_CONFIG;

  useEffect(() => {
    if (!isValid && customRef.current) {
      customRef.current.focus();
    }
  }, [customRef, isValid]);

  return COUNTRY === 'kr' ? (
    <DaumZipComponent />
  ) : (
    <FormField
      valid={isValid}
      validation={{
        msg: t('components.zipCode.errorMessage'),
        role: 'alert',
        'aria-live': 'assertive',
        id: `ZipCodeTextInputFieldError`,
        type: 'error',
      }}
      shouldValidate={!isValid}
    >
      <InputField
        id={name}
        type="text"
        value={newZipCode}
        label={t('components.zipCode.label')}
        onChange={handleChange}
        onBlur={handleBlur}
        autoComplete="postal-code"
        ref={customRef}
      />
    </FormField>
  );
};

export default ZipCode;
